// THE FIELDS OF A PAYMENT — amount, date, method — shared by the two places one is
// recorded, so they cannot drift apart:
//
//   PaymentModal        a payment against a charge already recorded (a later payment, an
//                       installment)
//   RecordChargeModal   the payment recorded with the charge itself, when the client had
//                       already paid by the time it is recorded
//
// Who collected it is NOT here: it is the invoice's issuer, which the recording dialog
// already asks and the payment dialog asks under its own rule (changeable only until the
// first payment). The server counterpart is server/api/rest/payments/prepare.js.
import { NumberInput, DateInput, Select } from './Form';
import { useLookups } from '../context/LookupsContext';
import he from '../i18n/he';

// `form` holds amount / payment_date / method; `set(key)` returns that field's onChange.
export default function PaymentFields({ form, set }) {
  const lookups = useLookups();
  return (
    <>
      <NumberInput label={he.payment.amount} value={form.amount} onChange={set('amount')} />
      <DateInput label={he.payment.date} value={form.payment_date} onChange={set('payment_date')} />
      <Select
        label={he.payment.method}
        value={form.method}
        onChange={set('method')}
        options={lookups.methodOptions}
      />
    </>
  );
}
